<template>
    <div class="facility-info-popup-container">
        <popup-modal @setAction="handleSetAction" @cancelAction="handleCancelAction">
            <facilities-modal :settings="facility">
                <template #header>
                    <p class="title">Equipment and Facilities</p>
                    <p class="subtitle">
                        List down any equipment and facilities your venue provides for the
                        artists.
                    </p>
                </template>
                <template #footer>
                    <div v-if="compErrMsg" class="input-err-msg">
                        {{ compErrMsg }}
                    </div>
                </template>
            </facilities-modal>
        </popup-modal>
    </div>
</template>
<script>
    import axios from 'axios'
    import PopupModal from '@/components/user/login-popups/PopupModal.vue'
    import FacilitiesModal from '@/components/ui/modals/FacilitiesModal.vue'

    const URLS = {
        user: '/profile/v1/settings/user/',
        facility: '/profile/v1/info/venue/facility-settings/'
    }

    export default {
        name: 'FacilityInfo',

        components: {
            'popup-modal': PopupModal,
            'facilities-modal': FacilitiesModal
        },

        emits: ['closeModalAction'],

        data: () => ({
            compErrMsg: '',

            facility: [
                {
                    name: 'sound-boards',
                    label: 'Sound boards',
                    selected: false,
                    description: ''
                },
                {
                    name: 'speakers',
                    label: 'Speakers',
                    selected: false,
                    description: ''
                },
                {
                    name: 'amplifiers',
                    label: 'Amplifiers',
                    selected: false,
                    description: ''
                },
                {
                    name: 'sound-mixers',
                    label: 'Sound mixers',
                    selected: false,
                    description: ''
                },
                {
                    name: 'microphones',
                    label: 'Microphones',
                    selected: false,
                    description: ''
                },
                {
                    name: 'projectors-screens',
                    label: 'Projectors/Screens',
                    selected: false,
                    description: ''
                },
                {
                    name: 'video-switchers',
                    label: 'Video switchers',
                    selected: false,
                    description: ''
                },
                {
                    name: 'stage-lights',
                    label: 'Stage lights',
                    selected: false,
                    description: ''
                },
                {
                    name: 'wifi',
                    label: 'Wifi',
                    selected: false,
                    description: ''
                },
                {
                    name: 'elevated-stage',
                    label: 'Elevated stage',
                    selected: false,
                    description: ''
                },
                {
                    name: 'tech-staff',
                    label: 'Tech support staff',
                    selected: false,
                    description: ''
                },
                {
                    name: 'other',
                    label: 'Other',
                    selected: false,
                    description: ''
                }
            ]
        }),

        methods: {
            prepSettingsData() {
                let data = {}

                let selected = this.facility.filter((val) => val.selected)

                for (let i = 0; i < selected.length; i++) {
                    data[selected[i]['name']] = selected[i]['description']
                }

                return JSON.stringify(data)
            },

            clearInputs() {
                this.compErrMsg = ''

                for (let i = 0; i < this.facility.length; i++) {
                    this.facility[i].selected = false
                    this.facility[i].description = ''
                }
            },

            inputsFilled() {
                let selected = this.facility.filter((v) => v.selected)

                if (selected.length) {
                    return true
                } else {
                    return false
                }
            },

            async handleSetAction() {
                this.compErrMsg = ''

                if (this.inputsFilled()) {
                    let settingsData = this.prepSettingsData()

                    await this.updateFacSettings(settingsData)
                    this.$emit('closeModalAction')
                } else {
                    this.compErrMsg = '[422] : You must enter some values to continue.'
                }
            },

            handleCancelAction() {
                this.clearInputs()
                this.$emit('closeModalAction')
            },

            async updateFacSettings(data) {
                try {
                    let userResp = await axios.get(this.URLS.user)
                    let userId = userResp.data.data[0].id

                    const facResp = await axios.post(this.URLS.facility + userId, {
                        _method: 'PUT',
                        settings: data
                    })
                    return facResp
                } catch (err) {
                    this.compErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                    throw err
                }
            }
        },

        computed: {
            URLS: () => URLS
        }
    }
</script>
<style lang="scss" scoped>
    .title {
        margin-top: 50px;
        margin-bottom: 0px;
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .subtitle {
        margin-top: 22px;
        margin-bottom: 0px;
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
</style>
